import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, {
  Path,
  Defs,
  LinearGradient,
  Stop,
} from "react-native-svg";

export default function AddIconGradient(props) {
  const width = props.width || 30;
  const height = props.height || 30;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M15.6003 8.94235C15.3347 8.94201 15.0798 9.0474 14.892 9.23524C14.7041 9.42309 14.5987 9.67796 14.5991 9.94361L14.6005 14.6006L9.94347 14.5992C9.39049 14.5992 8.94221 15.0475 8.94221 15.6005C8.94221 16.1535 9.39049 16.6017 9.94347 16.6017L14.6005 16.6003L14.5991 21.2573C14.5991 21.8103 15.0473 22.2586 15.6003 22.2586C16.1533 22.2586 16.6016 21.8103 16.6016 21.2573L16.6002 16.6003L21.2572 16.6017C21.6149 16.6017 21.9454 16.4109 22.1243 16.1011C22.3032 15.7913 22.3032 15.4096 22.1243 15.0998C21.9454 14.79 21.6149 14.5992 21.2572 14.5992L16.6002 14.6006L16.6016 9.94361C16.6019 9.67796 16.4965 9.42309 16.3087 9.23524C16.1209 9.0474 15.866 8.94201 15.6003 8.94235Z"
          fill="url(#paint0_linear_add_icon)"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.6001 15.6001C3.6001 8.97268 8.97268 3.6001 15.6001 3.6001C22.2248 3.60671 27.5935 8.97542 27.6001 15.6001C27.6001 22.2275 22.2275 27.6001 15.6001 27.6001C8.97268 27.6001 3.6001 22.2275 3.6001 15.6001ZM5.59998 15.6002C5.59998 21.123 10.0771 25.6002 15.6 25.6002C18.2521 25.6002 20.7957 24.5466 22.671 22.6712C24.5464 20.7959 25.6 18.2523 25.6 15.6002C25.6 10.0773 21.1228 5.60018 15.6 5.60018C10.0771 5.60018 5.59998 10.0773 5.59998 15.6002Z"
          fill="url(#paint1_linear)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_add_icon"
            x1="10.0611"
            y1="17.1341"
            x2="20.4231"
            y2="20.6864"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear"
            x1="3.6001"
            y1="8.80492"
            x2="15.1531"
            y2="32.4112"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
